export default __webpack_public_path__ + "static/media/select-arrow-dark.42ea320c.svg";